/**
 * Vault-side endpoints. Re-exports live behind a thin facade so
 * feature code imports `@/api/endpoints/vault` rather than digging
 * into mock-internals.
 */

import { api } from '../client';

export const vault = {
  snapshot: api.getVaultSnapshot,
  detail: api.getGiDetail,
  seedDemo: api.seedDemoData,
  reset: api.resetMock,
};
